export default __webpack_public_path__ + "static/media/IMG_1169.51cf32de.jpg";